import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'tzdate'
})
export class TzdatePipe implements PipeTransform {

	transform(value: unknown, format:string='MMM-DD-YYYY h:mm:ss A'): unknown {

		// Parse input considering as London tz
		var utc = moment.tz(value, 'UTC');

		// Converting input to Manila
		var timeInManila = utc.tz('Asia/Manila');
		// Show result
		return timeInManila.format(format);
	}

}
